<!-- HORIZONTAL TIMELINE: newest on the left, oldest on the right; click a point to see its changes -->
<div class="timeline-nav">
  <button
    mat-icon-button
    class="timeline-arrow"
    [class.arrow-hidden]="!hasOverflow"
    [disabled]="!canScrollLeft"
    (click)="scrollTimeline(-1)"
    aria-label="Newer actions">
    <mat-icon>chevron_left</mat-icon>
  </button>
  <div class="timeline-track" #timelineTrack (scroll)="updateScrollButtons()">
    <div class="timeline">
      @for (event of events; track event; let i = $index) {
        <button
          type="button"
          class="timeline-point"
          [class.selected]="i === selectedIndex"
          [class.assigned]="event.action === 'Assigned'"
          (click)="selectEvent(i)">
          <span class="point-date">{{ event.changedAt | utcToLocal: 'date' }}</span>
          <span class="point-time">{{ event.changedAt | utcToLocal: 'time' }}</span>
          <span class="point-dot-row"><span class="point-dot"></span></span>
          @if (event.changes?.length) {
            <span class="point-changes">
              @for (change of event.changes; track change) {
                <mat-icon
                  class="change-icon"
                  [ngClass]="'change-' + change.kind"
                [matTooltip]="change.tooltip">{{ changeIcon(change.kind) }}</mat-icon>
              }
            </span>
          } @else {
            <span class="point-action">{{ event.action }}</span>
          }
          <span class="point-user">{{ event.changedBy }}</span>
        </button>
      }
    </div>
  </div>
  <button
    mat-icon-button
    class="timeline-arrow"
    [class.arrow-hidden]="!hasOverflow"
    [disabled]="!canScrollRight"
    (click)="scrollTimeline(1)"
    aria-label="Older actions">
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
